import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: 999,
  padding: 4,
  border: `1px solid ${theme.palette.divider}`,
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "999px !important",
  },
}));

const StyledToggleButton = styled(ToggleButton)(() => ({
  borderRadius: 999,
  minWidth: 147.33,
  padding: "6px 20px",
  fontSize: 14,
  fontWeight: 400,
  color: "#888780",
  textTransform: "none",
  "&.Mui-selected": {
    backgroundColor: "#DBE0FC",
    color: "#3C3489",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#DBE0FC",
    },
  },
}));

export default function PillTab({ options = [], value, onChange }) {
  return (
    <StyledToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, val) => {
        if (val == null) return;
        const option = options.find(option => option.value === val);
        onChange?.(option);
      }}
    >
      {
        options.map(opt => (
          <StyledToggleButton
            key={opt.value}
            value={opt.value}
          >
            {opt.label}
          </StyledToggleButton>
        ))
      }
    </StyledToggleButtonGroup>
  );
}